<template>
  <v-layout>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card-actions>
          <div class="title">Orders</div>
<!--          <v-spacer></v-spacer>-->
<!--          <ManifestDialog>-->
<!--            <template v-slot:activator="{on}">-->
<!--              <v-btn v-on="on">Manifests</v-btn>-->
<!--            </template>-->
<!--          </ManifestDialog>-->
          <v-spacer></v-spacer>
          <CreateFromManifest @sample_submit="reloadSamples()">
            <template v-slot:activator="{on}">
              <v-btn v-on="on">Create Order</v-btn>
            </template>
          </CreateFromManifest>
          <!--      <CaCreateOrder>-->

          <!--      </CaCreateOrder>-->
        </v-card-actions>
      </v-col>
      <v-col cols="12">
<!--        <SampleTrackingTable ref="tracking_table">-->
<!--          <template v-slot:expanded_item="{item}">-->
<!--            <TableDropdown :sample="item"></TableDropdown>-->
<!--          </template>-->
<!--        </SampleTrackingTable>-->
        <SampleTable ref="tracking_table" :default_filter="{selectedOrder: {name: 'Created At Descending', key: 'created_at', desc: true}}">
          <template v-slot:expanded_item="{item}">
            <TableDropdown :sample="item"></TableDropdown>
          </template>
        </SampleTable>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
export default {
    name: "index",
    components: {
      // SampleTrackingTable: () => import("@/components/general/samples/SampleTrackingTable"),
      SampleTable: () => import('@/components/general/SamplesTable/SamplesTable'),
      TableDropdown: () => import("@/views/Tracking/components/TableDropdown"),
      ManifestDialog: () => import("@/views/orders/Manifests"),
      CreateFromManifest: () => import("@/views/orders/components/Manifest/CreateFromManifest")
    },
    data: () => ({}),
    mounted(){
      this.loadTypes()
    },
    methods: {
      reloadSamples(){
        this.$refs.tracking_table.loadQuery();
      },
      async loadTypes(){
        return await Promise.all([
            this.$store.$db().model('customers').api().fetch({with: 'primaryName'}),
            this.$store.$db().model('names').api().fetch(),
            // this.$store.$db().model('sampleTestTypes').api().fetch(),
            // this.$store.$db().model('sampleCertTypes').api().fetch(),
            // this.$store.$db().model('sampleFlagTypes').api().fetch(),
            this.$store.$db().model('sampleNoteTypes').api().fetch(),
            this.$store.$db().model('units').api().fetch(),
        ])
      }
    },
}
</script>

<style scoped>

</style>
